var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1377 0.830078C6.20944 0.830078 5.3192 1.19883 4.66282 1.8552C4.00644 2.51158 3.6377 3.40182 3.6377 4.33008C3.6377 5.15783 3.81386 5.69974 4.29395 6.29883L7.1377 9.58008L9.98145 6.29883C10.4615 5.69974 10.6377 5.15783 10.6377 4.33008C10.6377 3.40182 10.2689 2.51158 9.61257 1.8552C8.95619 1.19883 8.06595 0.830078 7.1377 0.830078V0.830078Z",
    stroke: "#111111",
    strokeWidth: 1.29167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0542 8.49707C1.97445 8.92115 1.3042 9.5109 1.3042 10.1637C1.3042 11.4528 3.91578 12.497 7.13753 12.497C10.3593 12.497 12.9709 11.4528 12.9709 10.1637C12.9709 9.5109 12.3006 8.92115 11.2209 8.49707",
    stroke: "#111111",
    strokeWidth: 1.29167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13753 4.91374C7.4597 4.91374 7.72087 4.65257 7.72087 4.3304C7.72087 4.00824 7.4597 3.74707 7.13753 3.74707C6.81537 3.74707 6.5542 4.00824 6.5542 4.3304C6.5542 4.65257 6.81537 4.91374 7.13753 4.91374Z",
    stroke: "#111111",
    strokeWidth: 1.29167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.90289994488a752e24297c5aa865f90a.svg";
export { ForwardRef as ReactComponent };